import { AppBar, Box, Container, Toolbar, Typography, useTheme } from "@mui/material";
import "./App.css";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import { InitializePage } from "./pages/initialize";
import { useContext } from "react";
import { AUTH_STATUS, AuthContext } from "./context/auth.provider";
import { Loading } from "./components/loading";
import { DemoElectionLayout, ElectionLayout } from "./pages/election";
import { LandingPage } from "./pages/landing-page";
import { Redirect } from "./components/redirect";
import { DisputePage } from "./pages/election/dispute";
import { CreateTicket } from "./pages/election/dispute/create-ticket";
import { ApiProvider } from "./context/api.provider";
import { ElectionOverviewPage } from "./pages/election/overview";
import { BallotLayout } from "./pages/election/ballot/ballot-layout";
import { LabelCacheProvider } from "./context/label-cache.provider";
import { BallotVote } from "./pages/election/ballot/ballot-vote";
import { BallotReview } from "./pages/election/ballot/ballot-review";
import { Logo } from "./components/logo";
import { LoginPage } from "./pages/login-page";
import { MainLayout } from "./layout/main-layout";
import { CenterLoading } from "./components/center-loading";
import { DEMO_MODE } from "./const/config";
import { DemoLandingPage } from "./pages/demo-landing-page";


const NotFound = () => {
  return (
    <>
      <Redirect to="/" />
      <Typography>Not found</Typography>
    </>
  );
};
const AuthArea = () => {
  const { status } = useContext(AuthContext);
  if (status !== AUTH_STATUS.AUTHENTICATED && !DEMO_MODE) {
    return <div>Not authorised</div>;
  }

  return (
    <ApiProvider>
      <LabelCacheProvider>
        <Outlet />
      </LabelCacheProvider>
    </ApiProvider>
  );
};
const routes = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout>
      {
        DEMO_MODE
          ? <DemoLandingPage />
          : <LandingPage />
      }
    </MainLayout>,
    errorElement: <NotFound />,
  },
  {
    path: "/login/:organisation_slug/:voting_round_slug",
    element: <LoginPage />,
  },
  {
    id: "auth_area",
    path: "",
    element: <AuthArea />,
    children: [
      {
        path: "/",
        element: <InitializePage />,
        id: "landing",
      },
      {
        path: "/voting/:election_id",
        element: DEMO_MODE ? <DemoElectionLayout /> : <ElectionLayout />,
        id: "election",
        children: [
          {
            index: true,
            element: <ElectionOverviewPage />,
            id: "election-index",
          },
          {
            path: "ballot/:ballot_id",
            element: <BallotLayout />,
            id: "ballot",
            children: [
              {
                path: "vote",
                element: <BallotVote />,
              },
              {
                path: "review",
                element: <BallotReview />,
              },
            ],
          },
          {
            path: "dispute",
            element: <DisputePage />,
            id: "dispute",
          },
          {
            path: "create-ticket",
            element: <CreateTicket />,
          },
        ],
      },
      {
        path: "create-ticket",
        element: <CreateTicket />,
      },
    ],
  },
]);

function App() {
  const { status } = useContext(AuthContext);
  if (status === AUTH_STATUS.VERIFYING) {
    return <CenterLoading />
  }
  return (
    <RouterProvider router={routes} />
  );
}

export default App;
